export default __webpack_public_path__ + "static/media/naac-logo.534e26fe.png";